import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthorizationService } from '../../libraries/auth/authorization.service';
import { BasePageComponent } from '../../libraries/base/page/base-page.component';
import { SPKListComponent } from './list/spk-list.component';
import { SPKListSummaryComponent } from './list-summary/spk-list-summary.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: '',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: SPKListComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'spk.read'
            }
          }
        ]
      },
      {
        path: 'spk-summary',
        component: BasePageComponent,
        children: [
          {
            path: '',
            component: SPKListSummaryComponent,
            canActivate: [AuthorizationService],
            data: {
              name: 'spk.read'
            }
          }
        ]
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SPKRoutingModule {}
